<template>
  <OrderPageSection is-panel>
    <OrderInfoTile label="订单支付信息" value="" />
    <OrderDescGroup
      v-for="(payment, index) in data"
      :key="index"
      :padding-y="16"
      :item-gap="12"
    >
      <OrderDescription
        type="amount"
        label="支付金额"
        :value="payment.amount"
      />
      <OrderDescription
        label="支付方式"
        :value="payMethod(payment.payModeSet)"
      />
      <OrderDescription
        type="time"
        label="支付时间"
        :value="payment.payTime"
        time-format="YYYY-MM-DD HH:mm:ss"
      />
      <OrderDescription label="流水号" :value="payment.icbcOrderId" />
    </OrderDescGroup>
  </OrderPageSection>
</template>

<script>
import { getEnumMap } from "@/api";
import OrderDescGroup from "../widgets/OrderDescGroup.vue";
import OrderDescription from "../widgets/OrderDescription.vue";
import OrderInfoTile from "../widgets/OrderInfoTile.vue";
import OrderPageSection from "../widgets/OrderPageSection.vue";

export default {
  components: {
    OrderPageSection,
    OrderInfoTile,
    OrderDescGroup,
    OrderDescription,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { inited: false, payMethodMap: {} };
  },
  mounted() {
    getEnumMap("PayModeSetEnum").then((map) => {
      this.payMethodMap = map;
      this.inited = true;
    });
  },
  methods: {
    payMethod(mode) {
      return this.inited ? this.payMethodMap[mode] || mode : "";
    },
  },
};
</script>
